import { Component } from '@angular/core';
import { ActivatedRoute, Router} from '@angular/router';
import { oktaLoginService } from './okta-login.service';
import { LoadingService } from '../shared/loading/loading.service';
import { AlertService } from '../shared/alerts/alerts.service';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-secure',
  template: `
    Redirecting to home...
  `
})
export class RedirectComponent {
  signIn;

  constructor(
      private route: ActivatedRoute,
      private router: Router,
      private loadingService: LoadingService,
      private alertService: AlertService,
      private authService: AuthService,
      private oLoginService: oktaLoginService
    ) {
    console.log("Redirect component");
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params=>{
      let code = params['code'];
      if( code && code.length){
        this.authenticateOktaCode( code);
      }
    });
  }

  authenticateOktaCode( code:string) {
    let params:any = {
      code: code
    }
    this.oLoginService.authenticateOkta( params).subscribe(sessionInfo => {
      // this.userId = sessionInfo.userId;
      this.authService.setSession( sessionInfo);
      console.log(sessionInfo);
      this.authService.navigate();
    }, err => this.loginError(err));
  }

  loginError(error: any) {
    this.loadingService.hideLoading();

    let data;
    try {
      data = JSON.parse(error._body);
    } catch (e) { }

    if ( data && data.code === 403 ) {
      this.router.navigate(['/login/access-denied']);
    } else {
      let errMsg = (data && (data.message || data.error)) || 'Error Occurred.';
      console.error( JSON.stringify(errMsg));
      const msg = errMsg.message || errMsg;
      this.alertService.createAlert(true, true, msg);
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/okta-login/redirect.component.ts